import React from "react";

import Meta from "../components/Meta";
import NewsletterForm from "../components/NewsletterForm";

const Newsletter = () => {
  return (
    <>

      <Meta
        title="Newsletter Engineering Book Club - Online community for reading books"
        desc="The Engineering Book Club is an online community for professional that wants to read books together."
      />

      <div className="pt-[5.5rem] lg:pt-24">
        <section className="dark:bg-jacarta-800 relative py-10">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full"
            />
          </picture>
          <div className="container">
            <div className="lg:flex lg:items-center lg:justify-between">

              <div className="pb-10 lg:w-[45%] lg:py-20 lg:pr-16">
                <h1 className="text-jacarta-700 font-display mb-2 text-2xl dark:text-white">
                  Engineering Book Club Newsletter
                </h1>
                <p className="dark:text-jacarta-60 mb-10 text-lg leading-normal">
                  A weekly email with the best of engineering books.
                </p>

                <NewsletterForm subscriptionList="892LQR763mQFYPM1763o763NqvT3Qw"/>

                <p className="dark:text-jacarta-60 mt-10 text-sm leading-normal">
                  Free 100%, join us and receive one weekly email. No spam, ever.
                </p>
              </div>

              <div className="lg:w-[55%]">
                <div className="relative">
                  <img
                    alt="engineering books"
                    src="/images/homepage/engineering-books.png"
                    className="mx-auto mt-8 w-[80%] rotate-[8deg] rounded-[10rem]"
                  />

                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default Newsletter;
